/*
 * Copyright (c) 2026.
 * Spin in het Web B.V. Apeldoorn.
 * Deze software mag alleen gebruikt / bekeken / gewijzigd worden volgens de voorwaarden die zijn vastgelegd in een bijbehorende schriftelijke overeenkomst met Spin in het Web B.V.
 */
import {ChangeDetectionStrategy, Component} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';
import {DlNodeVolgerDirective} from '../../../../../directives/dl-node-volger/dl-node-volger.directive';
import {BaseNodeMenuComponent} from '../../../base-node-menu.component';

@Component({
    selector: 'nodemenu-entity-agent',
    standalone: true,
    imports: [DlNodeVolgerDirective, TranslateModule],
    templateUrl: './nodemenu-entity-agent.component.html',
    styleUrls: ['./nodemenu-entity-agent.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class NodemenuEntityAgentComponent extends BaseNodeMenuComponent {
    constructor() {
        super();
    }
}
